/*
 * Module for the Service Purhase Payment Plans tab
*/

rs.module("content/participant/member/servicepurchase/paymentplans",

    ["content/participant/member/servicepurchase/paymentplanedit"],

    function (paymentPlanEdit) {

        //
        // Initialize
        //
        function initialize(jsSelectors, paymentPlansGrid, backendUrls, originalBalance, editAllowed) {

            var _executeSelectionChanged = false;

            // when add link is clicked, show a blank form for adding
            $.js(jsSelectors.addLink, { required: false }).click(function () {

                paymentPlansGrid.selectedValues = null;
                loadPayoffOptionDetail(null);
            });

            // when a payment plan is selected in the grid, load the selected payoff option
            paymentPlansGrid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    loadPayoffOptionDetail(values[0]);
                }

                _executeSelectionChanged = true;
            });

            // when the calc defaults link is clicked open the modal
            $.js(jsSelectors.calcDefaultsLink, { required: false }).click(function () {
                
                paymentPlansGrid.selectedValues = null;
                loadPayoffOptionDetail(null, true);
                $.js(jsSelectors.calcDefaultsModal).modal('show');
            });

            // when submit is clicked to calculate defaults, validate the input
            $.js(jsSelectors.calcDefaultsForm).submit(function (e) {

                // Validate form before performing calc
                var validator = $(this).validate();
                var isValid = validator.form();

                if (isValid) {
                    $.js(jsSelectors.calcDefaultsModal).js(jsSelectors.calcDefaultsSpinner).show();
                }
                else {
                    e.preventDefault();
                }
            });

            //
            // Load a payoff option for edit
            //
            function loadPayoffOptionDetail(payoffOptionKey, disabled) {

                $.get(
                    {
                        url: backendUrls.loadPayoffOption,
                        data: {
                            payoffOptionKey: payoffOptionKey,
                            originalBalance: originalBalance,
                            editAllowed: editAllowed
                        },
                        clearEventBanner: true

                    }).done(function (result) {

                        $.js(jsSelectors.paymentPlansForm).html(result);

                        if (disabled) {
                            // Disable the add/edit form
                            paymentPlanEdit.toggleInputs(false);
                        }
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);